import AdminAppointmentsContent from "../../../components/Admin/Appointments/index1"

const AdminAppointments = () => {

    return (
        <>
            <AdminAppointmentsContent />
        </>
    )

}

export default AdminAppointments